// store for the survey component
const state = () => ({
  sections: [], // all sections
});

const getters = {
  sections(state) {
    return state.sections;
  },
};

const mutations = {
  setSections(state, sections) {
    state.sections = sections;
  },
};

const actions = {

  // action to retrieve survey, CAE and Municipalities from backend and set them in the state
  async loadSections({ commit }) {
    try {
      // fetch the data from the backend (survey controller)
      const response = await fetch(process.env.VUE_APP_API_URL + '/home');
      if (!response.ok) {
        throw new Error('Erro ao conectar à base de dados.');
      }
      const responseData = await response.json();

      // Ensure the response data has the expected structure
      if (
        !responseData ||
        !responseData.sections
      ) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || 'Erro ao conectar à base de dados.');
      }

      // get individual arrays for each data and commit to the state
      const sections = responseData.sections;
      commit('setSections', sections);
      return true;
    } catch (error) {
      return error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};